///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { userRole } from "./types";

export const getTeamContactType = field => {
  switch (field) {
    case "salesRepresentative":
      return userRole.salesRep;
    case "truckloadPricing":
      return userRole.tlPricingAnalyst;
    case "lessThanTruckloadPricing":
      return userRole.ltlPricingAnalyst;
    case "intermodalPricing":
    default:
      return userRole.imdlPricingAnalyst;
  }
};

export default getTeamContactType;
